/**
 * Script pour mettre à jour dynamiquement le titre selon l'app
 */
export function setupDynamicTitle() {
  // Détecter l'app actuelle basée sur l'URL
  const pathname = window.location.pathname;

  // Utiliser le titre défini dans index.html comme fallback (GEO-friendly)
  const htmlTitle =
    document.querySelector("title")?.textContent?.trim() || "DooDates";
  let title = htmlTitle;

  // Overrides spécifiques par chemin (pour les apps multi-routes dans landing)
  if (pathname.includes("/form-polls")) {
    title = "DooDates - Form Polls";
  } else if (pathname.includes("/date-polls")) {
    title = "DooDates - Date Polls";
  } else if (pathname.includes("/quizz")) {
    title = "DooDates - Quizz";
  } else if (pathname.includes("/availability-polls")) {
    title = "DooDates - Availability Polls";
  } else if (pathname.includes("/DooDates/")) {
    title = "DooDates - Assistant IA pour Planification Collaborative";
  }

  // Mettre à jour le titre seulement si différent
  if (document.title !== title) {
    document.title = title;
  }

  // PAS de MutationObserver de restauration ici : il écrasait les titres
  // localisés posés par SEOHead/Helmet sur la landing (pathname "/") à chaque
  // switch de langue client-side. SEOHead est propriétaire du titre par page.
}
